// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: dataframe.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { KGObservationProto } from "./analysis_plan";
import { DarwinHeader, FileType, fileTypeFromJSON, fileTypeToJSON } from "./common";
import { ColumnHashProto } from "./data";

export const protobufPackage = "com.anko.darwin";

/** Details of a column in the KG dataframe. */
export interface DataFrameColumnProto {
  /** Output name of the column. */
  output_column_name?:
    | string
    | undefined;
  /**
   * True if column should be visible in the dataframe, false otherwise.
   * Some columns may be used to calculate other columns, in which case they can be marked as hidden.
   */
  is_visible?:
    | boolean
    | undefined;
  /**
   * Reference to a column in KG observation, referred by column hash.
   * This is set if this column refers to MKG entities in the KG observation.
   * If this column refers to some column in KG observation, Reference to KG observation column
   */
  column_hash?:
    | ColumnHashProto
    | undefined;
  /**
   * Evaluation expression (pandas) used for this column.
   * This is used for non-MKG columns in the dataframe.
   */
  eval_expression?:
    | string
    | undefined;
  /**
   * True if the eval expression represents an aggregate value, false otherwise.
   * If this is false, then eval expression is added as a column in dataframe.
   */
  is_aggregate_expression?:
    | boolean
    | undefined;
  /** String representation of JSON array of data values in this column. */
  data_value_json_array?: string | undefined;
}

/** Dataframe generated from a KG observation */
export interface KGDataFrameProto {
  /** The KG observation that generated this dataframe */
  kg_observation?:
    | KGObservationProto
    | undefined;
  /** Ordered list of columns */
  ordered_columns: DataFrameColumnProto[];
  /** Expression filters applied to rows */
  expression_filters: string[];
  /** Error messages during execution */
  error_messages: string[];
  /** List of columns on which sorting is applied. */
  sort_by_columns: KGDataFrameProto_SortByColumn[];
  /** Header containing metadata */
  header?:
    | DarwinHeader
    | undefined;
  /** pandas dataframe in kg_dataframe */
  pandas_dataframe?: PandasDataFrameProto | undefined;
}

export interface KGDataFrameProto_SortByColumn {
  /** Name of column */
  column_name?:
    | string
    | undefined;
  /** True if sort in ascending order, false otherwise */
  sort_asc?: boolean | undefined;
}

export interface PandasDataFrameProto {
  /** name of dataframe */
  name?:
    | string
    | undefined;
  /**
   * JSON string produced by pandas DataFrame.to_json() (default orient).
   * Top-level keys are column names; each maps to a dict of {row_index: value}.
   * Example (2 columns, 3 rows):
   *   {
   *     "date":    {"0": "2024-01-01", "1": "2024-01-02", "2": "2024-01-03"},
   *     "revenue": {"0": 1200.5,       "1": 980.0,        "2": 1540.75}
   *   }
   */
  data_json?:
    | string
    | undefined;
  /** map of column name to its corresponding pandas data types. */
  column_dtypes: PandasDataFrameProto_ColumnDtype[];
  format_map: PandasDataFrameProto_PdFormat[];
  /**
   * Opaque string payload from df.attrs["metadata"] — used by KGDataFrame to carry
   * serialized filter JSON alongside the raw data for display in Frida.
   */
  metadata?: string | undefined;
}

export interface PandasDataFrameProto_PdFormat {
  column_name?: string | undefined;
  row_index?: string | undefined;
  format_string?: string | undefined;
}

export interface PandasDataFrameProto_ColumnDtype {
  column_name?: string | undefined;
  dtype?: string | undefined;
}

/** Artifact loaded from an uploaded file — Darwin-internal only, never sent to Frida */
export interface FileArtifactProto {
  /** Header containing metadata (header.name = sanitized artifact name for LLM reference) */
  header?:
    | DarwinHeader
    | undefined;
  /** pandas dataframe — populated when file_type == CSV */
  pandas_dataframe?:
    | PandasDataFrameProto
    | undefined;
  /** Parquet filename on disk (stem with epoch suffix, e.g. "forecast_data_may_2025_1748418600.parquet") */
  filename?:
    | string
    | undefined;
  /** Type of the uploaded file */
  file_type?:
    | FileType
    | undefined;
  /** Vega/Vega-Lite chart spec serialized as JSON string — populated when file_type == CHART */
  chart_spec_json?:
    | string
    | undefined;
  /** DOCX file content as bytes — populated when file_type == DOCX */
  doc_bytes?:
    | Uint8Array
    | undefined;
  /**
   * Workflow run ID — set for artifacts stored under WORKFLOW_RUNS_BASE_DIR / run_id.
   * Used by the populate endpoint to reconstruct the correct file path on disk.
   */
  run_id?:
    | string
    | undefined;
  /** Raw image bytes — populated when file_type == PNG or JPEG */
  image_bytes?:
    | Uint8Array
    | undefined;
  /**
   * Raw PDF bytes — populated when file_type == PDF (native delivery to LLM)
   * For DOCX uploads this holds the DOCX-to-PDF converted bytes.
   */
  pdf_bytes?: Uint8Array | undefined;
}

export interface DataFrameAnalysisProto {
  /** Header containing metadata */
  header?:
    | DarwinHeader
    | undefined;
  /** list of names of parent dataframes. */
  parent_headers: DataFrameAnalysisProto_ParentHeader[];
  /** code to generate this dataframe. */
  code?:
    | string
    | undefined;
  /** pandas dataframes in this derived dataframe */
  pandas_dataframes: PandasDataFrameProto[];
  /** charts generated as part of this dataframe analysis */
  charts: DataFrameAnalysisProto_ChartProto[];
  /** Reports generated as part of this dataframe analysis */
  reports: DataFrameAnalysisProto_ReportProto[];
}

export interface DataFrameAnalysisProto_ChartProto {
  /** chart name shown in artifacts panel */
  name?:
    | string
    | undefined;
  /** Vega/Vega-Lite spec serialized as JSON string */
  spec_json?: string | undefined;
}

export interface DataFrameAnalysisProto_ReportProto {
  /** Report name, as of now it will contains pdf names. */
  name?:
    | string
    | undefined;
  /** PDF bytes */
  pdf_bytes?: Uint8Array | undefined;
}

export interface DataFrameAnalysisProto_ParentHeader {
  /** name of parent pandas dataframe */
  name?:
    | string
    | undefined;
  /** Header of analysis for which parent dataframe is part of. */
  header?: DarwinHeader | undefined;
}

function createBaseDataFrameColumnProto(): DataFrameColumnProto {
  return {
    output_column_name: undefined,
    is_visible: undefined,
    column_hash: undefined,
    eval_expression: undefined,
    is_aggregate_expression: undefined,
    data_value_json_array: undefined,
  };
}

export const DataFrameColumnProto: MessageFns<DataFrameColumnProto> = {
  encode(message: DataFrameColumnProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.output_column_name !== undefined) {
      writer.uint32(10).string(message.output_column_name);
    }
    if (message.is_visible !== undefined) {
      writer.uint32(16).bool(message.is_visible);
    }
    if (message.column_hash !== undefined) {
      ColumnHashProto.encode(message.column_hash, writer.uint32(26).fork()).join();
    }
    if (message.eval_expression !== undefined) {
      writer.uint32(34).string(message.eval_expression);
    }
    if (message.is_aggregate_expression !== undefined) {
      writer.uint32(40).bool(message.is_aggregate_expression);
    }
    if (message.data_value_json_array !== undefined) {
      writer.uint32(50).string(message.data_value_json_array);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameColumnProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameColumnProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.output_column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_visible = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.column_hash = ColumnHashProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.eval_expression = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_aggregate_expression = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.data_value_json_array = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameColumnProto {
    return {
      output_column_name: isSet(object.output_column_name) ? globalThis.String(object.output_column_name) : undefined,
      is_visible: isSet(object.is_visible) ? globalThis.Boolean(object.is_visible) : undefined,
      column_hash: isSet(object.column_hash) ? ColumnHashProto.fromJSON(object.column_hash) : undefined,
      eval_expression: isSet(object.eval_expression) ? globalThis.String(object.eval_expression) : undefined,
      is_aggregate_expression: isSet(object.is_aggregate_expression)
        ? globalThis.Boolean(object.is_aggregate_expression)
        : undefined,
      data_value_json_array: isSet(object.data_value_json_array)
        ? globalThis.String(object.data_value_json_array)
        : undefined,
    };
  },

  toJSON(message: DataFrameColumnProto): unknown {
    const obj: any = {};
    if (message.output_column_name !== undefined) {
      obj.output_column_name = message.output_column_name;
    }
    if (message.is_visible !== undefined) {
      obj.is_visible = message.is_visible;
    }
    if (message.column_hash !== undefined) {
      obj.column_hash = ColumnHashProto.toJSON(message.column_hash);
    }
    if (message.eval_expression !== undefined) {
      obj.eval_expression = message.eval_expression;
    }
    if (message.is_aggregate_expression !== undefined) {
      obj.is_aggregate_expression = message.is_aggregate_expression;
    }
    if (message.data_value_json_array !== undefined) {
      obj.data_value_json_array = message.data_value_json_array;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameColumnProto>, I>>(base?: I): DataFrameColumnProto {
    return DataFrameColumnProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameColumnProto>, I>>(object: I): DataFrameColumnProto {
    const message = createBaseDataFrameColumnProto();
    message.output_column_name = object.output_column_name ?? undefined;
    message.is_visible = object.is_visible ?? undefined;
    message.column_hash = (object.column_hash !== undefined && object.column_hash !== null)
      ? ColumnHashProto.fromPartial(object.column_hash)
      : undefined;
    message.eval_expression = object.eval_expression ?? undefined;
    message.is_aggregate_expression = object.is_aggregate_expression ?? undefined;
    message.data_value_json_array = object.data_value_json_array ?? undefined;
    return message;
  },
};

function createBaseKGDataFrameProto(): KGDataFrameProto {
  return {
    kg_observation: undefined,
    ordered_columns: [],
    expression_filters: [],
    error_messages: [],
    sort_by_columns: [],
    header: undefined,
    pandas_dataframe: undefined,
  };
}

export const KGDataFrameProto: MessageFns<KGDataFrameProto> = {
  encode(message: KGDataFrameProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(10).fork()).join();
    }
    for (const v of message.ordered_columns) {
      DataFrameColumnProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.expression_filters) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.error_messages) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.sort_by_columns) {
      KGDataFrameProto_SortByColumn.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(50).fork()).join();
    }
    if (message.pandas_dataframe !== undefined) {
      PandasDataFrameProto.encode(message.pandas_dataframe, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGDataFrameProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGDataFrameProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ordered_columns.push(DataFrameColumnProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expression_filters.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.error_messages.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sort_by_columns.push(KGDataFrameProto_SortByColumn.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.pandas_dataframe = PandasDataFrameProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGDataFrameProto {
    return {
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      ordered_columns: globalThis.Array.isArray(object?.ordered_columns)
        ? object.ordered_columns.map((e: any) => DataFrameColumnProto.fromJSON(e))
        : [],
      expression_filters: globalThis.Array.isArray(object?.expression_filters)
        ? object.expression_filters.map((e: any) => globalThis.String(e))
        : [],
      error_messages: globalThis.Array.isArray(object?.error_messages)
        ? object.error_messages.map((e: any) => globalThis.String(e))
        : [],
      sort_by_columns: globalThis.Array.isArray(object?.sort_by_columns)
        ? object.sort_by_columns.map((e: any) => KGDataFrameProto_SortByColumn.fromJSON(e))
        : [],
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      pandas_dataframe: isSet(object.pandas_dataframe)
        ? PandasDataFrameProto.fromJSON(object.pandas_dataframe)
        : undefined,
    };
  },

  toJSON(message: KGDataFrameProto): unknown {
    const obj: any = {};
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.ordered_columns?.length) {
      obj.ordered_columns = message.ordered_columns.map((e) => DataFrameColumnProto.toJSON(e));
    }
    if (message.expression_filters?.length) {
      obj.expression_filters = message.expression_filters;
    }
    if (message.error_messages?.length) {
      obj.error_messages = message.error_messages;
    }
    if (message.sort_by_columns?.length) {
      obj.sort_by_columns = message.sort_by_columns.map((e) => KGDataFrameProto_SortByColumn.toJSON(e));
    }
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.pandas_dataframe !== undefined) {
      obj.pandas_dataframe = PandasDataFrameProto.toJSON(message.pandas_dataframe);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGDataFrameProto>, I>>(base?: I): KGDataFrameProto {
    return KGDataFrameProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGDataFrameProto>, I>>(object: I): KGDataFrameProto {
    const message = createBaseKGDataFrameProto();
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.ordered_columns = object.ordered_columns?.map((e) => DataFrameColumnProto.fromPartial(e)) || [];
    message.expression_filters = object.expression_filters?.map((e) => e) || [];
    message.error_messages = object.error_messages?.map((e) => e) || [];
    message.sort_by_columns = object.sort_by_columns?.map((e) => KGDataFrameProto_SortByColumn.fromPartial(e)) || [];
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.pandas_dataframe = (object.pandas_dataframe !== undefined && object.pandas_dataframe !== null)
      ? PandasDataFrameProto.fromPartial(object.pandas_dataframe)
      : undefined;
    return message;
  },
};

function createBaseKGDataFrameProto_SortByColumn(): KGDataFrameProto_SortByColumn {
  return { column_name: undefined, sort_asc: undefined };
}

export const KGDataFrameProto_SortByColumn: MessageFns<KGDataFrameProto_SortByColumn> = {
  encode(message: KGDataFrameProto_SortByColumn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_name !== undefined) {
      writer.uint32(10).string(message.column_name);
    }
    if (message.sort_asc !== undefined) {
      writer.uint32(16).bool(message.sort_asc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGDataFrameProto_SortByColumn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGDataFrameProto_SortByColumn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sort_asc = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGDataFrameProto_SortByColumn {
    return {
      column_name: isSet(object.column_name) ? globalThis.String(object.column_name) : undefined,
      sort_asc: isSet(object.sort_asc) ? globalThis.Boolean(object.sort_asc) : undefined,
    };
  },

  toJSON(message: KGDataFrameProto_SortByColumn): unknown {
    const obj: any = {};
    if (message.column_name !== undefined) {
      obj.column_name = message.column_name;
    }
    if (message.sort_asc !== undefined) {
      obj.sort_asc = message.sort_asc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGDataFrameProto_SortByColumn>, I>>(base?: I): KGDataFrameProto_SortByColumn {
    return KGDataFrameProto_SortByColumn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGDataFrameProto_SortByColumn>, I>>(
    object: I,
  ): KGDataFrameProto_SortByColumn {
    const message = createBaseKGDataFrameProto_SortByColumn();
    message.column_name = object.column_name ?? undefined;
    message.sort_asc = object.sort_asc ?? undefined;
    return message;
  },
};

function createBasePandasDataFrameProto(): PandasDataFrameProto {
  return { name: undefined, data_json: undefined, column_dtypes: [], format_map: [], metadata: undefined };
}

export const PandasDataFrameProto: MessageFns<PandasDataFrameProto> = {
  encode(message: PandasDataFrameProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.data_json !== undefined) {
      writer.uint32(18).string(message.data_json);
    }
    for (const v of message.column_dtypes) {
      PandasDataFrameProto_ColumnDtype.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.format_map) {
      PandasDataFrameProto_PdFormat.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.metadata !== undefined) {
      writer.uint32(42).string(message.metadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PandasDataFrameProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePandasDataFrameProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data_json = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.column_dtypes.push(PandasDataFrameProto_ColumnDtype.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.format_map.push(PandasDataFrameProto_PdFormat.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PandasDataFrameProto {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      data_json: isSet(object.data_json) ? globalThis.String(object.data_json) : undefined,
      column_dtypes: globalThis.Array.isArray(object?.column_dtypes)
        ? object.column_dtypes.map((e: any) => PandasDataFrameProto_ColumnDtype.fromJSON(e))
        : [],
      format_map: globalThis.Array.isArray(object?.format_map)
        ? object.format_map.map((e: any) => PandasDataFrameProto_PdFormat.fromJSON(e))
        : [],
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : undefined,
    };
  },

  toJSON(message: PandasDataFrameProto): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.data_json !== undefined) {
      obj.data_json = message.data_json;
    }
    if (message.column_dtypes?.length) {
      obj.column_dtypes = message.column_dtypes.map((e) => PandasDataFrameProto_ColumnDtype.toJSON(e));
    }
    if (message.format_map?.length) {
      obj.format_map = message.format_map.map((e) => PandasDataFrameProto_PdFormat.toJSON(e));
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PandasDataFrameProto>, I>>(base?: I): PandasDataFrameProto {
    return PandasDataFrameProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PandasDataFrameProto>, I>>(object: I): PandasDataFrameProto {
    const message = createBasePandasDataFrameProto();
    message.name = object.name ?? undefined;
    message.data_json = object.data_json ?? undefined;
    message.column_dtypes = object.column_dtypes?.map((e) => PandasDataFrameProto_ColumnDtype.fromPartial(e)) || [];
    message.format_map = object.format_map?.map((e) => PandasDataFrameProto_PdFormat.fromPartial(e)) || [];
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBasePandasDataFrameProto_PdFormat(): PandasDataFrameProto_PdFormat {
  return { column_name: undefined, row_index: undefined, format_string: undefined };
}

export const PandasDataFrameProto_PdFormat: MessageFns<PandasDataFrameProto_PdFormat> = {
  encode(message: PandasDataFrameProto_PdFormat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_name !== undefined) {
      writer.uint32(10).string(message.column_name);
    }
    if (message.row_index !== undefined) {
      writer.uint32(18).string(message.row_index);
    }
    if (message.format_string !== undefined) {
      writer.uint32(26).string(message.format_string);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PandasDataFrameProto_PdFormat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePandasDataFrameProto_PdFormat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.row_index = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.format_string = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PandasDataFrameProto_PdFormat {
    return {
      column_name: isSet(object.column_name) ? globalThis.String(object.column_name) : undefined,
      row_index: isSet(object.row_index) ? globalThis.String(object.row_index) : undefined,
      format_string: isSet(object.format_string) ? globalThis.String(object.format_string) : undefined,
    };
  },

  toJSON(message: PandasDataFrameProto_PdFormat): unknown {
    const obj: any = {};
    if (message.column_name !== undefined) {
      obj.column_name = message.column_name;
    }
    if (message.row_index !== undefined) {
      obj.row_index = message.row_index;
    }
    if (message.format_string !== undefined) {
      obj.format_string = message.format_string;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PandasDataFrameProto_PdFormat>, I>>(base?: I): PandasDataFrameProto_PdFormat {
    return PandasDataFrameProto_PdFormat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PandasDataFrameProto_PdFormat>, I>>(
    object: I,
  ): PandasDataFrameProto_PdFormat {
    const message = createBasePandasDataFrameProto_PdFormat();
    message.column_name = object.column_name ?? undefined;
    message.row_index = object.row_index ?? undefined;
    message.format_string = object.format_string ?? undefined;
    return message;
  },
};

function createBasePandasDataFrameProto_ColumnDtype(): PandasDataFrameProto_ColumnDtype {
  return { column_name: undefined, dtype: undefined };
}

export const PandasDataFrameProto_ColumnDtype: MessageFns<PandasDataFrameProto_ColumnDtype> = {
  encode(message: PandasDataFrameProto_ColumnDtype, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_name !== undefined) {
      writer.uint32(10).string(message.column_name);
    }
    if (message.dtype !== undefined) {
      writer.uint32(18).string(message.dtype);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PandasDataFrameProto_ColumnDtype {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePandasDataFrameProto_ColumnDtype();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dtype = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PandasDataFrameProto_ColumnDtype {
    return {
      column_name: isSet(object.column_name) ? globalThis.String(object.column_name) : undefined,
      dtype: isSet(object.dtype) ? globalThis.String(object.dtype) : undefined,
    };
  },

  toJSON(message: PandasDataFrameProto_ColumnDtype): unknown {
    const obj: any = {};
    if (message.column_name !== undefined) {
      obj.column_name = message.column_name;
    }
    if (message.dtype !== undefined) {
      obj.dtype = message.dtype;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PandasDataFrameProto_ColumnDtype>, I>>(
    base?: I,
  ): PandasDataFrameProto_ColumnDtype {
    return PandasDataFrameProto_ColumnDtype.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PandasDataFrameProto_ColumnDtype>, I>>(
    object: I,
  ): PandasDataFrameProto_ColumnDtype {
    const message = createBasePandasDataFrameProto_ColumnDtype();
    message.column_name = object.column_name ?? undefined;
    message.dtype = object.dtype ?? undefined;
    return message;
  },
};

function createBaseFileArtifactProto(): FileArtifactProto {
  return {
    header: undefined,
    pandas_dataframe: undefined,
    filename: undefined,
    file_type: undefined,
    chart_spec_json: undefined,
    doc_bytes: undefined,
    run_id: undefined,
    image_bytes: undefined,
    pdf_bytes: undefined,
  };
}

export const FileArtifactProto: MessageFns<FileArtifactProto> = {
  encode(message: FileArtifactProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.pandas_dataframe !== undefined) {
      PandasDataFrameProto.encode(message.pandas_dataframe, writer.uint32(18).fork()).join();
    }
    if (message.filename !== undefined) {
      writer.uint32(26).string(message.filename);
    }
    if (message.file_type !== undefined) {
      writer.uint32(32).int32(message.file_type);
    }
    if (message.chart_spec_json !== undefined) {
      writer.uint32(42).string(message.chart_spec_json);
    }
    if (message.doc_bytes !== undefined) {
      writer.uint32(50).bytes(message.doc_bytes);
    }
    if (message.run_id !== undefined) {
      writer.uint32(58).string(message.run_id);
    }
    if (message.image_bytes !== undefined) {
      writer.uint32(66).bytes(message.image_bytes);
    }
    if (message.pdf_bytes !== undefined) {
      writer.uint32(74).bytes(message.pdf_bytes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileArtifactProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileArtifactProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pandas_dataframe = PandasDataFrameProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.file_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.chart_spec_json = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.doc_bytes = reader.bytes();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.run_id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.image_bytes = reader.bytes();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.pdf_bytes = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileArtifactProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      pandas_dataframe: isSet(object.pandas_dataframe)
        ? PandasDataFrameProto.fromJSON(object.pandas_dataframe)
        : undefined,
      filename: isSet(object.filename) ? globalThis.String(object.filename) : undefined,
      file_type: isSet(object.file_type) ? fileTypeFromJSON(object.file_type) : undefined,
      chart_spec_json: isSet(object.chart_spec_json) ? globalThis.String(object.chart_spec_json) : undefined,
      doc_bytes: isSet(object.doc_bytes) ? bytesFromBase64(object.doc_bytes) : undefined,
      run_id: isSet(object.run_id) ? globalThis.String(object.run_id) : undefined,
      image_bytes: isSet(object.image_bytes) ? bytesFromBase64(object.image_bytes) : undefined,
      pdf_bytes: isSet(object.pdf_bytes) ? bytesFromBase64(object.pdf_bytes) : undefined,
    };
  },

  toJSON(message: FileArtifactProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.pandas_dataframe !== undefined) {
      obj.pandas_dataframe = PandasDataFrameProto.toJSON(message.pandas_dataframe);
    }
    if (message.filename !== undefined) {
      obj.filename = message.filename;
    }
    if (message.file_type !== undefined) {
      obj.file_type = fileTypeToJSON(message.file_type);
    }
    if (message.chart_spec_json !== undefined) {
      obj.chart_spec_json = message.chart_spec_json;
    }
    if (message.doc_bytes !== undefined) {
      obj.doc_bytes = base64FromBytes(message.doc_bytes);
    }
    if (message.run_id !== undefined) {
      obj.run_id = message.run_id;
    }
    if (message.image_bytes !== undefined) {
      obj.image_bytes = base64FromBytes(message.image_bytes);
    }
    if (message.pdf_bytes !== undefined) {
      obj.pdf_bytes = base64FromBytes(message.pdf_bytes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileArtifactProto>, I>>(base?: I): FileArtifactProto {
    return FileArtifactProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileArtifactProto>, I>>(object: I): FileArtifactProto {
    const message = createBaseFileArtifactProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.pandas_dataframe = (object.pandas_dataframe !== undefined && object.pandas_dataframe !== null)
      ? PandasDataFrameProto.fromPartial(object.pandas_dataframe)
      : undefined;
    message.filename = object.filename ?? undefined;
    message.file_type = object.file_type ?? undefined;
    message.chart_spec_json = object.chart_spec_json ?? undefined;
    message.doc_bytes = object.doc_bytes ?? undefined;
    message.run_id = object.run_id ?? undefined;
    message.image_bytes = object.image_bytes ?? undefined;
    message.pdf_bytes = object.pdf_bytes ?? undefined;
    return message;
  },
};

function createBaseDataFrameAnalysisProto(): DataFrameAnalysisProto {
  return { header: undefined, parent_headers: [], code: undefined, pandas_dataframes: [], charts: [], reports: [] };
}

export const DataFrameAnalysisProto: MessageFns<DataFrameAnalysisProto> = {
  encode(message: DataFrameAnalysisProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.parent_headers) {
      DataFrameAnalysisProto_ParentHeader.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.code !== undefined) {
      writer.uint32(26).string(message.code);
    }
    for (const v of message.pandas_dataframes) {
      PandasDataFrameProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.charts) {
      DataFrameAnalysisProto_ChartProto.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.reports) {
      DataFrameAnalysisProto_ReportProto.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameAnalysisProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameAnalysisProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parent_headers.push(DataFrameAnalysisProto_ParentHeader.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pandas_dataframes.push(PandasDataFrameProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.charts.push(DataFrameAnalysisProto_ChartProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.reports.push(DataFrameAnalysisProto_ReportProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameAnalysisProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      parent_headers: globalThis.Array.isArray(object?.parent_headers)
        ? object.parent_headers.map((e: any) => DataFrameAnalysisProto_ParentHeader.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      pandas_dataframes: globalThis.Array.isArray(object?.pandas_dataframes)
        ? object.pandas_dataframes.map((e: any) => PandasDataFrameProto.fromJSON(e))
        : [],
      charts: globalThis.Array.isArray(object?.charts)
        ? object.charts.map((e: any) => DataFrameAnalysisProto_ChartProto.fromJSON(e))
        : [],
      reports: globalThis.Array.isArray(object?.reports)
        ? object.reports.map((e: any) => DataFrameAnalysisProto_ReportProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DataFrameAnalysisProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.parent_headers?.length) {
      obj.parent_headers = message.parent_headers.map((e) => DataFrameAnalysisProto_ParentHeader.toJSON(e));
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.pandas_dataframes?.length) {
      obj.pandas_dataframes = message.pandas_dataframes.map((e) => PandasDataFrameProto.toJSON(e));
    }
    if (message.charts?.length) {
      obj.charts = message.charts.map((e) => DataFrameAnalysisProto_ChartProto.toJSON(e));
    }
    if (message.reports?.length) {
      obj.reports = message.reports.map((e) => DataFrameAnalysisProto_ReportProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameAnalysisProto>, I>>(base?: I): DataFrameAnalysisProto {
    return DataFrameAnalysisProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameAnalysisProto>, I>>(object: I): DataFrameAnalysisProto {
    const message = createBaseDataFrameAnalysisProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.parent_headers = object.parent_headers?.map((e) => DataFrameAnalysisProto_ParentHeader.fromPartial(e)) ||
      [];
    message.code = object.code ?? undefined;
    message.pandas_dataframes = object.pandas_dataframes?.map((e) => PandasDataFrameProto.fromPartial(e)) || [];
    message.charts = object.charts?.map((e) => DataFrameAnalysisProto_ChartProto.fromPartial(e)) || [];
    message.reports = object.reports?.map((e) => DataFrameAnalysisProto_ReportProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDataFrameAnalysisProto_ChartProto(): DataFrameAnalysisProto_ChartProto {
  return { name: undefined, spec_json: undefined };
}

export const DataFrameAnalysisProto_ChartProto: MessageFns<DataFrameAnalysisProto_ChartProto> = {
  encode(message: DataFrameAnalysisProto_ChartProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.spec_json !== undefined) {
      writer.uint32(18).string(message.spec_json);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameAnalysisProto_ChartProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameAnalysisProto_ChartProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spec_json = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameAnalysisProto_ChartProto {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      spec_json: isSet(object.spec_json) ? globalThis.String(object.spec_json) : undefined,
    };
  },

  toJSON(message: DataFrameAnalysisProto_ChartProto): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.spec_json !== undefined) {
      obj.spec_json = message.spec_json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameAnalysisProto_ChartProto>, I>>(
    base?: I,
  ): DataFrameAnalysisProto_ChartProto {
    return DataFrameAnalysisProto_ChartProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameAnalysisProto_ChartProto>, I>>(
    object: I,
  ): DataFrameAnalysisProto_ChartProto {
    const message = createBaseDataFrameAnalysisProto_ChartProto();
    message.name = object.name ?? undefined;
    message.spec_json = object.spec_json ?? undefined;
    return message;
  },
};

function createBaseDataFrameAnalysisProto_ReportProto(): DataFrameAnalysisProto_ReportProto {
  return { name: undefined, pdf_bytes: undefined };
}

export const DataFrameAnalysisProto_ReportProto: MessageFns<DataFrameAnalysisProto_ReportProto> = {
  encode(message: DataFrameAnalysisProto_ReportProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.pdf_bytes !== undefined) {
      writer.uint32(18).bytes(message.pdf_bytes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameAnalysisProto_ReportProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameAnalysisProto_ReportProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pdf_bytes = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameAnalysisProto_ReportProto {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      pdf_bytes: isSet(object.pdf_bytes) ? bytesFromBase64(object.pdf_bytes) : undefined,
    };
  },

  toJSON(message: DataFrameAnalysisProto_ReportProto): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.pdf_bytes !== undefined) {
      obj.pdf_bytes = base64FromBytes(message.pdf_bytes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameAnalysisProto_ReportProto>, I>>(
    base?: I,
  ): DataFrameAnalysisProto_ReportProto {
    return DataFrameAnalysisProto_ReportProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameAnalysisProto_ReportProto>, I>>(
    object: I,
  ): DataFrameAnalysisProto_ReportProto {
    const message = createBaseDataFrameAnalysisProto_ReportProto();
    message.name = object.name ?? undefined;
    message.pdf_bytes = object.pdf_bytes ?? undefined;
    return message;
  },
};

function createBaseDataFrameAnalysisProto_ParentHeader(): DataFrameAnalysisProto_ParentHeader {
  return { name: undefined, header: undefined };
}

export const DataFrameAnalysisProto_ParentHeader: MessageFns<DataFrameAnalysisProto_ParentHeader> = {
  encode(message: DataFrameAnalysisProto_ParentHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataFrameAnalysisProto_ParentHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataFrameAnalysisProto_ParentHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataFrameAnalysisProto_ParentHeader {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
    };
  },

  toJSON(message: DataFrameAnalysisProto_ParentHeader): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataFrameAnalysisProto_ParentHeader>, I>>(
    base?: I,
  ): DataFrameAnalysisProto_ParentHeader {
    return DataFrameAnalysisProto_ParentHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataFrameAnalysisProto_ParentHeader>, I>>(
    object: I,
  ): DataFrameAnalysisProto_ParentHeader {
    const message = createBaseDataFrameAnalysisProto_ParentHeader();
    message.name = object.name ?? undefined;
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
